import { AddressDTO } from "./AddressDTO";

export class FooterDataDTO {
    cnpj: string;
    email: string;
    whatsAppCell: string;
    phone: string;
    address: AddressDTO;

    constructor(sub?) {
        sub = sub || {};

        this.cnpj = sub.cnpj || null;
        this.email = sub.email || null;
        this.whatsAppCell = sub.whatsAppCell || null;
        this.phone = sub.phone || null;
        this.address = new AddressDTO(sub.address);
    }
}
